/* House of Whiskerton — Shopify theme interactions. Vanilla JS, no deps. */
(function () {
  "use strict";
  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var search = (window.location && window.location.search || "").toLowerCase();
  var paidPath = /(?:\?|&)(utm_medium=paid|utm_source=meta|utm_source=facebook|utm_source=instagram|hw_mode=buy)(?:&|$)/.test(search);

  /* ---- Shopify money format (standard helper) ---- */
  var MONEY_FORMAT = window.HW_MONEY_FORMAT || "${{amount}}";
  function formatMoney(cents, format) {
    if (typeof cents === "string") cents = cents.replace(".", "");
    var value = "", placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, f = format || MONEY_FORMAT;
    function defaultTo(n, d) { return n == null ? d : n; }
    function thousands(num, precision, thousand, decimal) {
      precision = defaultTo(precision, 2); thousand = defaultTo(thousand, ","); decimal = defaultTo(decimal, ".");
      if (isNaN(num) || num == null) return 0;
      num = (num / 100).toFixed(precision);
      var parts = num.split("."), dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousand),
          centsPart = parts[1] ? decimal + parts[1] : "";
      return dollars + centsPart;
    }
    switch (f.match(placeholderRegex)[1]) {
      case "amount": value = thousands(cents, 2); break;
      case "amount_no_decimals": value = thousands(cents, 0); break;
      case "amount_with_comma_separator": value = thousands(cents, 2, ".", ","); break;
      case "amount_no_decimals_with_comma_separator": value = thousands(cents, 0, ".", ","); break;
      default: value = thousands(cents, 2);
    }
    return f.replace(placeholderRegex, value);
  }

  /* ---- placeholders ---- */
  $$("[data-year]").forEach(function (el) { el.textContent = new Date().getFullYear(); });

  /* ---- announcement ---- */
  var announce = $("#announce");
  if (announce) {
    if (sessionStorage.getItem("hw_announce") === "closed") announce.style.display = "none";
    var ac = $(".close", announce);
    if (ac) ac.addEventListener("click", function () { announce.style.display = "none"; sessionStorage.setItem("hw_announce", "closed"); });
    if (paidPath) announce.style.display = "none";
  }

  /* ---- mobile nav ---- */
  var burger = $(".burger"), drawer = $("#drawer"), scrim = $("#scrim");
  function toggleNav(open) {
    if (!drawer) return;
    drawer.classList.toggle("open", open); scrim.classList.toggle("open", open);
    burger.classList.toggle("open", open); document.body.style.overflow = open ? "hidden" : "";
  }
  if (burger) burger.addEventListener("click", function () { toggleNav(!drawer.classList.contains("open")); });
  if (scrim) scrim.addEventListener("click", function () { toggleNav(false); });
  $$("#drawer a").forEach(function (a) { a.addEventListener("click", function () { toggleNav(false); }); });

  /* ---- accordion ---- */
  $$(".acc").forEach(function (acc) {
    var q = $(".acc__q", acc), a = $(".acc__a", acc);
    if (!q || !a) return;
    q.addEventListener("click", function () {
      var open = acc.classList.toggle("open");
      a.style.maxHeight = open ? a.scrollHeight + "px" : 0;
    });
  });

  /* ---- before/after ---- */
  $$(".ba").forEach(function (ba) {
    var before = $(".ba__before", ba), handle = $(".ba__handle", ba), dragging = false;
    if (!before || !handle) return;
    function set(x) { var r = ba.getBoundingClientRect(), p = ((x - r.left) / r.width) * 100; p = Math.max(4, Math.min(96, p)); before.style.width = p + "%"; handle.style.left = p + "%"; }
    function move(e) { if (!dragging) return; set(e.touches ? e.touches[0].clientX : e.clientX); }
    ba.addEventListener("mousedown", function (e) { dragging = true; set(e.clientX); });
    ba.addEventListener("touchstart", function (e) { dragging = true; set(e.touches[0].clientX); }, { passive: true });
    window.addEventListener("mousemove", move); window.addEventListener("touchmove", move, { passive: true });
    window.addEventListener("mouseup", function () { dragging = false; }); window.addEventListener("touchend", function () { dragging = false; });
  });

  /* ---- scroll reveal ---- */
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); } });
    }, { threshold: .12, rootMargin: "0px 0px -8% 0px" });
    $$(".reveal").forEach(function (el) { io.observe(el); });
  } else { $$(".reveal").forEach(function (el) { el.classList.add("in"); }); }

  /* ---- toast ---- */
  var toast = $("#toast"), toastTimer;
  function showToast(html) {
    if (!toast) return;
    toast.innerHTML = html; toast.classList.add("show");
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { toast.classList.remove("show"); }, 4200);
  }

  /* =================== PRODUCT FORM (Shopify variants) =================== */
  var root = $("#MainProduct");
  if (root) {
    if (paidPath) {
      document.documentElement.classList.add("hw-paid-path");
      root.setAttribute("data-paid-path", "true");
      var sub = $(".buybox .sub", root);
      if (sub) sub.textContent = "Order today, then approve your proof before we print. AI-crafted, human-reviewed, and backed by the Love-It Guarantee.";
      var ctaWrap = $(".buybox__cta", root);
      if (ctaWrap && !ctaWrap.querySelector('.field-note--paid')) {
        var paidNote = document.createElement('p');
        paidNote.className = 'field-note field-note--paid';
        paidNote.style.textAlign = 'center';
        paidNote.textContent = 'This paid-traffic page is buy-first on purpose. Your proof still arrives before anything prints.';
        ctaWrap.appendChild(paidNote);
      }
      var uploadTitle = $(".upload__title", root);
      var uploadHint = $(".upload__hint", root);
      if (uploadTitle) uploadTitle.textContent = "Upload your pet photo now or after checkout";
      if (uploadHint) uploadHint.textContent = "Fastest path: add to cart now, then send the photo if you are ready.";
    }
    var dataEl = $("#ProductJson", root);
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var form = $("#product-form", root);
    var idInput = $("#variantId", root);
    var priceEl = $("#price", root);
    var compareEl = $("#price-compare", root);
    var saveEl = $("#price-save", root);
    var ctaBtn = $("#mainCta", root);
    var barPrice = $("#barPrice");
    var optionGroups = $$("[data-option-index]", root);

    function selectedOptions() {
      return optionGroups.map(function (g) {
        var checked = $("input:checked", g);
        return checked ? checked.value : null;
      });
    }
    function findVariant(opts) {
      return variants.find(function (v) {
        return opts.every(function (val, i) { return val == null || v.options[i] === val; });
      });
    }
    function updateLabels() {
      optionGroups.forEach(function (g) {
        var checked = $("input:checked", g), valEl = $(".val", g);
        $$(".pill", g).forEach(function (p) { p.classList.toggle("active", p.contains(checked)); });
        if (checked && valEl) valEl.textContent = checked.value;
      });
    }
    function render() {
      updateLabels();
      var v = findVariant(selectedOptions());
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (compareEl) { if (v.compare_at_price && v.compare_at_price > v.price) { compareEl.style.display = ""; compareEl.textContent = formatMoney(v.compare_at_price); if (saveEl) { saveEl.style.display = ""; saveEl.textContent = "Save " + formatMoney(v.compare_at_price - v.price); } } else { compareEl.style.display = "none"; if (saveEl) saveEl.style.display = "none"; } }
      if (barPrice && barPrice.childNodes[0]) barPrice.childNodes[0].nodeValue = formatMoney(v.price);
      if (ctaBtn) {
        if (v.available) { ctaBtn.disabled = false; ctaBtn.querySelector(".btn-label") && (ctaBtn.querySelector(".btn-label").textContent = "Add to cart — " + formatMoney(v.price)); }
        else { ctaBtn.disabled = true; ctaBtn.querySelector(".btn-label") && (ctaBtn.querySelector(".btn-label").textContent = "Sold out"); }
      }
    }
    optionGroups.forEach(function (g) { g.addEventListener("change", render); });

    /* photo upload preview */
    var upload = $("#upload", root), fileInput = $("#fileInput", root), hasFile = false;
    if (upload && fileInput) {
      var prev = $(".upload__preview img", upload), fname = $(".fname", upload);
      function setFile(file) { if (!file) return; hasFile = true; upload.classList.add("has-file"); if (fname) fname.textContent = file.name; if (prev && file.type.indexOf("image/") === 0) prev.src = URL.createObjectURL(file); }
      fileInput.addEventListener("change", function (e) { setFile(e.target.files[0]); });
      ["dragover", "dragenter"].forEach(function (ev) { upload.addEventListener(ev, function (e) { e.preventDefault(); upload.classList.add("drag"); }); });
      ["dragleave", "drop"].forEach(function (ev) { upload.addEventListener(ev, function (e) { e.preventDefault(); upload.classList.remove("drag"); }); });
      upload.addEventListener("drop", function (e) { if (e.dataTransfer.files[0]) { fileInput.files = e.dataTransfer.files; setFile(e.dataTransfer.files[0]); } });
      var clr = $(".upload__clear", upload);
      if (clr) clr.addEventListener("click", function (e) { e.preventDefault(); e.stopPropagation(); hasFile = false; fileInput.value = ""; upload.classList.remove("has-file"); });
    }

    /* require a photo + add the £12 digital add-on before submit */
    if (form) {
      var bumpEl = $("#bump", root);
      form.addEventListener("submit", function (e) {
        if (!paidPath && fileInput && fileInput.required === false && !hasFile) {
          e.preventDefault();
          showToast("<b>One thing first</b><p>Upload a photo of your pet so we can start the portrait.</p>");
          if (upload) upload.scrollIntoView({ behavior: "smooth", block: "center" });
          return;
        }
        if (bumpEl && bumpEl.checked && bumpEl.dataset.addonVariant && !form.dataset.addonAdded) {
          e.preventDefault();
          form.dataset.addonAdded = "1";
          var go = function () { if (form.requestSubmit) form.requestSubmit(); else form.submit(); };
          fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: Number(bumpEl.dataset.addonVariant), quantity: 1 }) }).then(go).catch(go);
        }
      });
    }

    /* sticky buy bar */
    var bar = $("#buybar"), barBtn = $("#barCta");
    if (bar && ctaBtn && "IntersectionObserver" in window) {
      new IntersectionObserver(function (e) { bar.classList.toggle("show", !e[0].isIntersecting); }, { threshold: 0 }).observe(ctaBtn);
    }
    if (barBtn && form) barBtn.addEventListener("click", function () { if (form.requestSubmit) form.requestSubmit(); else form.submit(); });

    if (paidPath) {
      $$("a[href*='/pages/free-preview']").forEach(function (el) { el.style.display = "none"; });
      $$(".cta-or", root).forEach(function (el) { el.style.display = "none"; });
      $$(".pdp-spec__item", document).forEach(function (el) {
        if (/free preview first/i.test(el.innerText || '')) el.style.display = 'none';
      });
    }

    render();
  }
})();
